jQuery(document).ready(function(){
var delay = $('.main-slider').attr('data-delay');
if (typeof delay !== typeof undefined && delay !== false) {    
} else{
  delay = 8000;
}

var width = $('.main-slider').attr('data-width');
if (typeof width !== typeof undefined && width !== false) {    
} else{
  width = 1920;
}

var height = $('.main-slider').attr('data-height');
if (typeof height !== typeof undefined && height !== false) {    
} else{
  height = 775;
}




jQuery('#rev_slider').show().revolution({ 
  dottedOverlay: 'none',
  delay: delay,
  startwidth: width, 
  startheight: height, 

  hideThumbs:200,
  thumbWidth:100,                            
  thumbHeight:50, 
  thumbAmount:5,

  navigationType:"both",                  
  navigationArrows:"",        
  navigationStyle: 'default',             
  touchenabled:"on",                      
  onHoverStop:"on",        

  navOffsetHorizontal:0,
  navOffsetVertical:50,

  swipe_velocity: 0.7, 
  swipe_min_touches: 1,
  swipe_max_touches: 1,
  drag_block_vertical: false,

  spinner: 'spinner2',
  keyboardNavigation: 'on',

  navigationHAlign: 'center',
  navigationVAlign: 'bottom',
  navigationHOffset: 20,
  navigationVOffset: 20,

  soloArrowLeftHalign: '',
  soloArrowLeftValign: '',
  soloArrowLeftHOffset: 0,
  soloArrowLeftVOffset: 0,

  soloArrowRightHalign: '',
  soloArrowRightValign: '',
  soloArrowRightHOffset: 0,
  soloArrowRightVOffset: 0,

  shadow: 0,
  fullWidth: 'on',
  fullScreen: 'off', 

  stopLoop: 'off',
  stopAfterLoops: -1,
  stopAtSlide: -1,

  shuffle: 'off',
  autoHeight: 'on',
  forceFullWidth: 'off',
  hideTimerBar: 'on',

  hideNavDelayOnMobile: 1500,
  hideThumbsOnMobile: 'off',
  hideBulletsOnMobile: 'off',
  hideArrowsOnMobile: 'off',
  hideThumbsUnderResolution: 0,

  hideSliderAtLimit: 0,
  hideCaptionAtLimit: 0,
  hideAllCaptionAtLilmit: 0,
  startWithSlide: 0
});
})
